import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import nl from "./locales/nl.json";
import pt from "./locales/pt.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
            nl: { translation: nl },
            pt: { translation: pt },
        },
        fallbackLng: "en",
        supportedLngs: ["en", "fr", "nl", "pt"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage"],
            caches: ["localStorage"],
            lookupLocalStorage: "barefoot-lang",
        },
        returnObjects: true,
    });

export default i18n;
